// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import '../third/jquery.slick';

export default class ItemSlider extends WebComponent {
  didMount() {
    const isReviewsSlider = this.element.classList.contains('reviews__slider');
    const isSpecialOfferSlider = this.element.classList.contains('special-offer__slider');
    const isCooperationSlider = this.element.classList.contains('cooperation__slider');

    //setTimeout(() => {
      if (isReviewsSlider) {
        // page gallery
        $(this.element).slick({
          mobileFirst: true,
          arrows: false,
          dots: true,
          prevArrow: '<span class="reviews-slider__arrow reviews-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#prev"></use></svg></span>',
          nextArrow: '<span class="reviews-slider__arrow reviews-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#next"></use></svg></span>',
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          speed: 400,
          cssEase: 'ease-out',
          draggable: true,
          variableWidth: false,
          centerPadding: '0',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
              },
            },
          ],
        });
      } else if (isSpecialOfferSlider) {
        $(this.element).slick({
          mobileFirst: true,
          arrows: true,
          dots: false,
          prevArrow: '<span class="special-offer__arrow special-offer__arrow--prev"><svg class="svg-icon"><use xlink:href="#prev"></use></svg></span>',
          nextArrow: '<span class="special-offer__arrow special-offer__arrow--next"><svg class="svg-icon"><use xlink:href="#next"></use></svg></span>',
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          speed: 400,
          cssEase: 'ease-out',
          draggable: true,
          variableWidth: false,
          centerPadding: '0',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } else if (isCooperationSlider) {
        $(this.element).slick({
          autoplay: true,
          autoplaySpeed: 2500,
          pauseOnHover: true,
          //touchThreshold: 2,
          mobileFirst: true,
          arrows: false,
          dots: false,
          infinite: true,
          centerMode: true,
          cssEase: 'linear',
          draggable: true,
          variableWidth: true,
          centerPadding: '0',
        });
      }


    //}, 200);

    $(window).resize(() => {
      $(this.element).slick('resize');
    });

    $('[data-slick-reinit]').on('click', function() {
      let tData = $(this).data('slickReinit');
      $(tData).slick('reinit');
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/ItemSlider.js